import { render, staticRenderFns } from "./ModalImagesCategories.vue?vue&type=template&id=6581a369&scoped=true&lang=pug&"
import script from "./ModalImagesCategories.vue?vue&type=script&lang=js&"
export * from "./ModalImagesCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6581a369",
  null
  
)

export default component.exports